import React from 'react';

import Icon from './Icon';

// Utils
import Dictionary from '@/types/dictionary';
import { ARROW_COLORS } from '../../../utils/colors';

export type Props = {
  id?: string;
  type: string;
  title?: string;
  margin?: string;
  ariaHidden?: boolean;
  useHTMLEntity?: boolean;
};

const ArrowTypes: Dictionary<string> = {
  'full-down': 'arrow-full-down',
  'full-up': 'arrow-full-up',
  up: 'arrow-up',
  down: 'arrow-down',
};

const getIconClass = (type: string) => ArrowTypes[type];

const getIconColor = (type: string) => ARROW_COLORS[type] || 'black';

const getArrowEntity = (type: string): string => {
  switch (type) {
    case 'full-down':
      return '\u23F7';
    case 'full-up':
      return '\u23F6';
    case 'up':
      return '\u2191';
    case 'down':
    default:
      return '\u2193';
  }
};

const ArrowIcon: React.FC<Props> = ({ id, type, title, margin, ariaHidden, useHTMLEntity }) => {
  if (useHTMLEntity) {
    return (
      <span id={id} aria-label={title} role="img" aria-hidden={ariaHidden} style={{ margin, color: getIconColor(type) }}>
        {getArrowEntity(type)}
      </span>
    );
  }
  return (
    <Icon
      id={id}
      color={getIconColor(type)}
      role="graphics-symbol"
      type={getIconClass(type)}
      size={12}
      boxPad={100}
      title={title}
      margin={margin}
      aria-hidden={ariaHidden}
    />
  );
};

export default ArrowIcon;
